<template>
  <div class="tw-flex tw-justify-between tw-items-center tw-pt-6 tw-border-t">
    <div>
      <Button
        v-if="!isFirstStep"
        variant="outline"
        @click="handlePrevious"
        :disabled="loading"
        class="tw-gap-2"
        type="button"
      >
        <ChevronLeft class="tw-w-4 tw-h-4" />
        {{ $t('common.forms.previous') }}
      </Button>
    </div>
    <div>
      <Button
        v-if="!isLastStep"
        @click="handleNext"
        :disabled="loading"
        class="tw-gap-2"
        type="button"
      >
        {{ $t('common.forms.next') }}
        <ChevronRight class="tw-w-4 tw-h-4" />
      </Button>
      <Button v-else @click="handleFinish" :disabled="loading" class="tw-gap-2" type="button">
        {{ $t('common.forms.finish') }}
        <ChevronRight class="tw-w-4 tw-h-4" />
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-vue-next';

interface StepFooterProps {
  currentStep: number;
  totalSteps: number;
  loading?: boolean;
}

interface StepFooterEmits {
  next: [];
  previous: [];
  finish: [];
}

const props = withDefaults(defineProps<StepFooterProps>(), {
  loading: false,
});

const emit = defineEmits<StepFooterEmits>();

const isLastStep = computed(() => props.currentStep === props.totalSteps);
const isFirstStep = computed(() => props.currentStep === 1);

const handleNext = () => {
  emit('next');
};

const handlePrevious = () => {
  emit('previous');
};

const handleFinish = () => {
  emit('finish');
};
</script>
